import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import muiTheme from "./muiTheme";

function ThemeRoot({ children }) {
  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export default ThemeRoot;
